// extracted by mini-css-extract-plugin
module.exports = {"OmniBar":"BQvqFedA","modalBody":"_2sRfqq5Q","query":"_1eXmuSub","queryIcon":"_18iRBuW9"};